import { render, staticRenderFns } from "./ErrorLogList.vue?vue&type=template&id=228ead76"
import script from "./ErrorLogList.vue?vue&type=script&lang=js"
export * from "./ErrorLogList.vue?vue&type=script&lang=js"
import style0 from "./ErrorLogList.vue?vue&type=style&index=0&id=228ead76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports